// Borrowed from the Google suite's color language, so a doc, sheet or deck is recognisable
// at a glance before its title is read.
export type DocumentTone =
  | "doc"
  | "sheet"
  | "slides"
  | "canvas"
  | "browser"
  | "desktop"
  | "media"
  | "space"
  | "pdf"
  | "file"
  | "runner";

interface DocumentToneClassNames {
  tile: string;
  border: string;
}

export const documentToneClassNames: Record<
  DocumentTone,
  DocumentToneClassNames
> = {
  doc: {
    tile: "bg-blue-50 text-blue-600 dark:bg-blue-950 dark:text-blue-300",
    border:
      "border-blue-600/25 hover:border-blue-600/50 dark:border-blue-400/25 dark:hover:border-blue-400/50",
  },
  sheet: {
    tile: "bg-emerald-50 text-emerald-600 dark:bg-emerald-950 dark:text-emerald-300",
    border:
      "border-emerald-600/25 hover:border-emerald-600/50 dark:border-emerald-400/25 dark:hover:border-emerald-400/50",
  },
  slides: {
    tile: "bg-amber-50 text-amber-500 dark:bg-amber-950 dark:text-amber-300",
    border:
      "border-amber-600/25 hover:border-amber-600/50 dark:border-amber-400/25 dark:hover:border-amber-400/50",
  },
  canvas: {
    tile: "bg-orange-50 text-orange-500 dark:bg-orange-950 dark:text-orange-300",
    border:
      "border-orange-600/25 hover:border-orange-600/50 dark:border-orange-400/25 dark:hover:border-orange-400/50",
  },
  browser: {
    tile: "bg-violet-50 text-violet-600 dark:bg-violet-950 dark:text-violet-300",
    border:
      "border-violet-600/25 hover:border-violet-600/50 dark:border-violet-400/25 dark:hover:border-violet-400/50",
  },
  desktop: {
    tile: "bg-cyan-50 text-cyan-600 dark:bg-cyan-950 dark:text-cyan-300",
    border:
      "border-cyan-600/25 hover:border-cyan-600/50 dark:border-cyan-400/25 dark:hover:border-cyan-400/50",
  },
  media: {
    tile: "bg-rose-50 text-rose-600 dark:bg-rose-950 dark:text-rose-300",
    border:
      "border-rose-600/25 hover:border-rose-600/50 dark:border-rose-400/25 dark:hover:border-rose-400/50",
  },
  space: {
    tile: "bg-indigo-50 text-indigo-600 dark:bg-indigo-950 dark:text-indigo-300",
    border:
      "border-indigo-600/25 hover:border-indigo-600/50 dark:border-indigo-400/25 dark:hover:border-indigo-400/50",
  },
  pdf: {
    tile: "bg-red-50 text-red-600 dark:bg-red-950 dark:text-red-300",
    border:
      "border-red-600/25 hover:border-red-600/50 dark:border-red-400/25 dark:hover:border-red-400/50",
  },
  file: {
    tile: "bg-slate-100 text-slate-600 dark:bg-slate-900 dark:text-slate-300",
    border:
      "border-slate-600/25 hover:border-slate-600/50 dark:border-slate-400/25 dark:hover:border-slate-400/50",
  },
  runner: {
    tile: "bg-teal-50 text-teal-600 dark:bg-teal-950 dark:text-teal-300",
    border:
      "border-teal-600/25 hover:border-teal-600/50 dark:border-teal-400/25 dark:hover:border-teal-400/50",
  },
};
